import { render, staticRenderFns } from "./scjihua.vue?vue&type=template&id=acb43b7e&scoped=true"
import script from "./scjihua.vue?vue&type=script&lang=js"
export * from "./scjihua.vue?vue&type=script&lang=js"
import style0 from "./scjihua.vue?vue&type=style&index=0&id=acb43b7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb43b7e",
  null
  
)

export default component.exports